import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import { Avatar, Dropdown } from "antd";
import { observer } from "mobx-react";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { globalStores } from "../../GlobalStores";
import { COLORS, ROUTES } from "../../common/constants";
import { LogoutIcon } from "../../common/icons";
import { LOCAL_STORAGE_TYPE, getLocalStorage } from "../../common/localStorage";
import { clearOnLogout } from "../../common/utils";
import { dashboardStores } from "../../pages/Dashboard/DashboardStores";
import AdAccount from "../AdAccount";
import AppSelector from "../AppSelector";
import { Language } from "../Language";
import NotificationBell from "../NotificationBell";

const KEY = {
  LANGUAGE: "LANGUAGE",
  LOGOUT: "LOGOUT",
};

const Topnav = observer(() => {
  const [userFullname, setUserfullname] = useState("");

  const location = useLocation();
  const { t } = useTranslation();

  useEffect(() => {
    setUserfullname(getLocalStorage(LOCAL_STORAGE_TYPE.USER_FULL_NAME));
  }, []);

  const items = useMemo(
    () => [
      {
        key: KEY.LANGUAGE,
        label: <Language />,
      },
      {
        type: "divider",
      },
      {
        key: KEY.LOGOUT,
        label: (
          <div className="cursor-pointer flex items-center gap-2 text-danger">
            <LogoutIcon />
            <span>{t("Logout")}</span>
          </div>
        ),
      },
    ],
    [t],
  );

  const onClickMenu = useCallback(
    ({ key }) => {
      switch (key) {
        case KEY.LOGOUT:
          window.location.href = dashboardStores.isVP() ? "/login/vpbank" : "/login";
          clearOnLogout();
          break;
        default:
          break;
      }
    },
    [],
  );

  const avatarChar = userFullname?.slice(0, 1)?.toUpperCase();
  const avatarColor = COLORS[avatarChar?.charCodeAt(0) % COLORS.length];

  const selector = useMemo(() => {
    if (location.pathname.includes("/retail-media/advertiser")) return <AdAccount />;
    if (["/setting", "/audit-log"].some((route) => location.pathname.includes(route))) return;
    // Màn Ứng dụng: thao tác trên từng thẻ app, không dùng app đang chọn
    if (location.pathname === ROUTES.application) return;
    return <AppSelector />;
  }, [location.pathname]);

  return (
    <nav className="navbar navbar-top navbar-expand navbar-dark bg-gradient-primary !px-0 !py-2 !sticky top-0 z-[101]">
      <div className="container-fluid flex items-center justify-between !px-[15px]">
        <div>{selector}</div>
        <div className="float-right flex items-center">
          <div
            className="mr-1 text-white text-lg flex-center cursor-pointer p-1.5 rounded hover:bg-[#5e72e4] lg:hidden"
            onClick={() => globalStores.setSidebarCollapse(!globalStores.sidebarCollapse)}
          >
            {globalStores.sidebarCollapse ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
          </div>
          <div className="!mr-4 flex-center">
            <NotificationBell />
          </div>
          <Dropdown menu={{ items, onClick: onClickMenu }} trigger="click" overlayClassName="w-64">
            <div className="flex items-center gap-2 cursor-pointer">
              <Avatar size={36} style={{ background: avatarColor }} className="font-bold text-white">
                {avatarChar}
              </Avatar>
              <div className="hidden lg:block text-white text-sm font-semibold">{userFullname}</div>
            </div>
          </Dropdown>
        </div>
      </div>
    </nav>
  );
});

export default Topnav;
